export default __webpack_public_path__ + "static/media/20180124_Justice_Paix_Logo_RVB-Positif@2x.4574dffd.png";